/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_SubtitleInputs */

const cs_clients_tags_subtitle = /** @type {(inputs: Clients_Tags_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spravovaný slovník s počty použití. Přejmenování na existující štítek sloučí přiřazení.`)
};

const en_clients_tags_subtitle = /** @type {(inputs: Clients_Tags_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managed vocabulary with usage counts. Renaming into an existing tag merges assignments.`)
};

/**
* | output |
* | --- |
* | "Managed vocabulary with usage counts. Renaming into an existing tag merges assignments." |
*
* @param {Clients_Tags_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_subtitle = /** @type {((inputs?: Clients_Tags_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_subtitle(inputs)
	return cs_clients_tags_subtitle(inputs)
});